// extracted by mini-css-extract-plugin
module.exports = {"notificationsWarning":"holdingSummary_notificationsWarning__1zdSN","icon":"holdingSummary_icon__aFOJw","text":"holdingSummary_text__3b84J"};